<template lang="pug">
    v-text-field.date-field( 
        :hide-details="hideDetails"
        :outline="outline"
        ref="field" 
        readonly 
        single-line
        :solo="solo"
        v-bind="fieldProps" 
        v-model="formatted" 
    )
        template( slot="append" )
            v-tooltip( bottom )
                template( slot="activator" )
                    v-btn( :color="isReadonly ? 'default' : 'primary'" icon flat @click="modal = true" )
                        v-icon today
                span {{ this.isReadonly ? "Ver calendario" : "Seleccionar fecha" }}
        slot( name="prepend" slot="prepend" )
            v-dialog( v-model="modal" :width="290" )
                v-date-picker( locale="es" v-bind="pickerProps" v-model="date" )        
        slot( name="prepend-inner" slot="prepend-inner" )
</template>

<script>
    export default {
        name: "date-field",
        computed: {

            /**
             * 
             */
            isReadonly () {
                return this.pickerProps.readonly
            }
        },
        data () {
            return {
                date: "",
                formatted: "",
                modal: false,
            }
        },
        props: {

            /**
             * 
             */
            fieldProps: {
                type: Object,
                default: () => ({})
            },

            /**
             * 
             */
            hideDetails: Boolean,            
            
            /**
             * 
             */
            pickerProps: {
                type: Object,
                default: () => ({})
            }, 
            
            /**
             *
             */
            outline: Boolean,
            solo: Boolean,

            /**
             * 
             */
            value: String,
        },
        methods: {

            /**
             * 
             */
            format ( data ) {

                //
                const date  = new Date( data )
                    , year  = date.getFullYear()
                    , month = date.getMonth() + 1 < 10 ? "0" + ( date.getMonth() + 1 ) : date.getMonth() + 1
                    , day   = date.getDate() + 1 < 10 ? "0" + ( date.getDate() + 1 ) : date.getDate() + 1

                //
                return isNaN(year) || isNaN( month ) || isNaN( day ) ? ''  : [ day, month, year ].join( "-" )
            },

            /**
             * 
             */
            reset () {
                this.date = this.value || ""; console.log(this.value)
            }
        },
        mounted () {
            this.reset()
        },
        watch: {

            /**
             * 
             */
            date () {
                this.formatted = this.format( this.date ); console.log( this.formatted )
            },

            /**
             * 
             */
            formatted () {
                if ( !this.pickerProps.readonly ) this.$emit( 'input', this.date )
            },

            /**
             * 
             */
            value () {
                this.reset()
            }
        },
    }
</script>

<style>
    .date-field .v-input__prepend-outer {
        margin: 0;
    }
    .date-field.v-text-field--outline .v-btn.v-btn--flat.v-btn--icon {
        margin-top: -8px;
    }
    .date-field.v-text-field--solo .v-btn.v-btn--flat.v-btn--icon {
        margin-bottom: 6px;
    }
</style>
